<mat-sidenav-container>
  <mat-sidenav>
    Sidenav content
  </mat-sidenav>

  <mat-sidenav-content>

    <app-nav></app-nav>

    <div [hidden]="!hideSmsCode">
      <mat-card style="box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.43);">
        <div style="padding: 10px 5px 5px 5px;">
          <span
            style="padding: 0px 0px 0px 20px;font-family: Roboto;font-size: 20px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #4a4a4a;">Sign in</span>

          <form [formGroup]="phoneNumber">
            <mat-form-field appearance="standard" style="width:80px;padding: 20px;">
              <mat-label>Country code</mat-label>
              <mat-select [formControl]="code" style="width:100px;text-align: center;">
                <mat-option value="+{{code.num}}" *ngFor="let code of codes">{{code.iso}} +{{code.num}}</mat-option>
              </mat-select>
              <!--              <mat-hint align="center">Select country please</mat-hint>-->

            </mat-form-field>
            <mat-form-field appearance="standard" style="width:120px;padding: 20px 0px 0px 20px">
              <mat-label>Phone number</mat-label>
              <input matInput #input minlength="7" [formControl]="userIdOpen" (keydown)="registerAppKeys($event)"
                     [autofocus]="hideSmsCode">
              <!--              <mat-hint align="center">Min 10 numbers</mat-hint>-->
            </mat-form-field>

          </form>
          <div style="text-align: right;">
            <button (click)="registerApp()" [disabled]="!userIdOpen.valid" mat-flat-button mat-button
                    style="color:{{con.theme.buttonText}}; background-color: {{con.theme.buttonBackground}}; width: 104px;align-items: flex-end;">
              Next >
            </button>
          </div>
        </div>
      </mat-card>
    </div>


    <div [hidden]="hideSmsCode">


      <mat-card style="box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.43); width: 380px;">

        <div style="padding: 10px 5px 5px 5px;">

          <span
            style="padding: 0px 0px 0px 20px;font-family: Roboto;font-size: 20px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #4a4a4a;">
            SMS send to<br> {{formatPhone(code.value + userIdOpen.value)}}
          </span>

          <form [formGroup]="smsConfirmation">
            <mat-form-field appearance="standard" style="padding: 20px 0px 0px 20px; width: 280px;">
              <mat-label>SMS or email code</mat-label>
              <input matInput #input (keydown)="confirmAppKeys($event)" [autofocus]="focusSmsCode"
                     [formControl]="smsCode">
              <mat-error *ngIf="!smsCodeErrorHide">
                {{errStr}}
              </mat-error>
            </mat-form-field>
          </form>
          <div class="email-recovery">
            <button *ngIf="!showEmailFallback && con.emailRecoverySupported === true" mat-button type="button" (click)="lookupRecoveryEmail()"
                    [disabled]="maskLookupLoading || maskLookupCooldown > 0 || !userIdOpen.valid">
              <span *ngIf="!maskLookupLoading && maskLookupCooldown === 0">SMS not arriving?</span>
              <span *ngIf="maskLookupLoading">Checking recovery options...</span>
              <span *ngIf="!maskLookupLoading && maskLookupCooldown > 0">Try again in {{maskLookupCooldown}}s</span>
            </button>
            <div *ngIf="showEmailFallback" class="email-recovery-form">
              <p *ngIf="maskedEmail">A verified email is linked to this number: <strong>{{maskedEmail}}</strong></p>
              <p *ngIf="!maskedEmail">No verified email is linked. For a new account, verify an email address here to continue without SMS. Existing accounts can use only their already verified recovery email.</p>
              <mat-form-field appearance="standard" class="email-recovery-field">
                <mat-label>{{maskedEmail ? 'Linked email address' : 'Email address'}}</mat-label>
                <input matInput type="email" autocomplete="email" [formControl]="fallbackEmail">
                <mat-error *ngIf="fallbackEmail.hasError('required')">Enter your linked email address.</mat-error>
                <mat-error *ngIf="fallbackEmail.hasError('email')">Enter a valid email address.</mat-error>
                <mat-error *ngIf="fallbackEmail.hasError('maxlength')">Email address is too long.</mat-error>
              </mat-form-field>
              <div class="email-recovery-actions">
                <button mat-button type="button" (click)="hideRecoveryEmail()" [disabled]="fallbackSending">Hide</button>
                <button mat-flat-button color="primary" type="button" (click)="sendRecoveryEmail()"
                        [disabled]="!fallbackEmail.valid || fallbackSending || fallbackCooldown > 0">
                  <span *ngIf="fallbackCooldown === 0">{{emailOnlyRegistrationFallback ? 'Send code by email' : 'Send code by SMS and email'}}</span>
                  <span *ngIf="fallbackCooldown > 0">Try again in {{fallbackCooldown}}s</span>
                </button>
              </div>
            </div>
            <p class="email-recovery-message" *ngIf="fallbackMessage">{{fallbackMessage}}</p>
            <p class="email-recovery-error" *ngIf="fallbackError" role="alert">{{fallbackError}}</p>
          </div>
          <div style="text-align: right;">
            <a (click)="back()" mat-button style="width: 104px;align-items: flex-end; margin-right: 10px">< Back </a>
            <button (click)="confirmApp()" [disabled]="!smsCode.valid" mat-flat-button mat-button color="primary"
                    style="color:{{con.theme.buttonText}}; background-color: {{con.theme.buttonBackground}}; width: 104px;align-items: flex-end; ">
              Next >
            </button>
          </div>

        </div>

      </mat-card>


    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
